export const hippoBG = require("./ubuntu-hippo.png");
export const ubuntuDevicesDesktop = require("./ubuntu_overlay-fs8.png");
export const ubuntuDevicesMobile = require("./ubuntu_overlay-fs8.png");
